module.exports = __webpack_public_path__ + "static/img/jingji.bfa8d7c3.png";